import React, { useEffect, useState } from "react";
import { useDealStatusSelector } from "store";

interface StatusComponentGuardProps {
  children: React.ReactNode;
  conditionRender?: boolean;
  statuses?: number[];
  show?: boolean;
}

export const StatusComponentGuard: React.FC<StatusComponentGuardProps> = ({
  children,
  statuses = [],
  conditionRender,
  show
}: StatusComponentGuardProps): JSX.Element => {
  const dealStatus = useDealStatusSelector();
  const [shouldRender, setShouldRender] = useState<boolean>(false);
  useEffect(() => {
    if (!dealStatus) return;
    if (show) {
      setShouldRender(statuses.includes(dealStatus?.id));
    }
    if (!show) {
      setShouldRender(!statuses.includes(dealStatus?.id));
    }
  }, [dealStatus]);

  // Render the children based on conditions
  if (conditionRender) {
    return <>{children}</>;
  }
  // Render the children based on statuses
  if (shouldRender) {
    return <>{children}</>;
  }
  return <></>;
};
